export const POST_ARTISTELAPP_RETURN = 'POST_ARTISTELAPP_RETURN';
export const POST_ARTISTELAPP_SAGAS = 'POST_ARTISTELAPP_SAGAS';

export const GET_ARTISTELAPPS_RETURN = 'GET_ARTISTELAPPS_RETURN';
export const GET_ARTISTELAPPS_SAGAS = 'GET_ARTISTELAPPS_SAGAS';

export const GET_ARTISTELAPP_RETURN = 'GET_ARTISTELAPP_RETURN';
export const GET_ARTISTELAPP_SAGAS = 'GET_ARTISTELAPP_SAGAS';

export const PUT_ARTISTELAPP_RETURN = 'PUT_ARTISTELAPP_RETURN';
export const PUT_ARTISTELAPP_SAGAS = 'PUT_ARTISTELAPP_SAGAS';

export const DEL_ARTISTELAPP_RETURN = 'DEL_ARTISTELAPP_RETURN';
export const DEL_ARTISTELAPP_SAGAS = 'DEL_ARTISTELAPP_SAGAS';

// POST ARTISTE (LAPP)
export const postArtisteLappSagas = (xAccess, data) => ({
	type: POST_ARTISTELAPP_SAGAS,
	token: xAccess,
	data: data
});
export const postArtisteLappReturn = (result) => ({
	type: POST_ARTISTELAPP_RETURN,
	payload: result
});

// GET ARTISTES (LAPP)
export const getArtisteLappsSagas = (xAccess) => ({
	type: GET_ARTISTELAPPS_SAGAS,
	token: xAccess
});
export const getArtisteLappsReturn = (result) => ({
	type: GET_ARTISTELAPPS_RETURN,
	payload: result
});

// GET ARTISTE (LAPP)
export const getArtisteLappSagas = (uuid, xAccess) => ({
	type: GET_ARTISTELAPP_SAGAS,
	token: xAccess,
	payload: uuid
});
export const getArtisteLappReturn = (result) => ({
	type: GET_ARTISTELAPP_RETURN,
	payload: result
});

// PUT ARTISTE (LAPP)
export const putArtisteLappSagas = (uuid, xAccess, data) => ({
	type: PUT_ARTISTELAPP_SAGAS,
	token: xAccess,
	payload: uuid,
	data: data
});
export const putArtisteLappReturn = (result) => ({
	type: PUT_ARTISTELAPP_RETURN,
	payload: result
});

// DELETE ARTISTE (LAPP)
export const deleteArtisteLappSagas = (uuid, xAccess) => ({
	type: DEL_ARTISTELAPP_SAGAS,
	token: xAccess,
	payload: uuid
});
export const deleteArtisteLappReturn = (result) => ({
	type: DEL_ARTISTELAPP_RETURN,
	payload: result
});
